import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {profileHistoryStateSelector} from './profile-history-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {ProfileChangeRecord} from 'src/openapi/admin/models/ProfileChangeRecord';

export const profileHistorySlice = getCachedTableDataSlice<
    ProfileChangeRecord[],
    undefined,
    undefined,
    undefined
>('roleProfileHistory');

export const profileHistoryActions = profileHistorySlice.actions;
export const profileHistoryCacheSelector: CachedTableCacheSelector<ProfileChangeRecord[]>
    = state => state.adminRights.profileHistory.result.cache;
export const profileHistoryDataSelector: CachedTableDataSelector<ProfileChangeRecord[]>
    = state => state.adminRights.profileHistory.result;
export const profileHistoryResultSelector = getCachedTableResultSelector(
    profileHistoryCacheSelector,
    profileHistoryStateSelector,
);
